export default __webpack_public_path__ + "static/media/arrow-down.d4851c6d.svg";